module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD5SURBVHgBrVI7CsJAEJ0kFmnFRqwiiqT0AIJXsBRFFGy9gmBjKV5BsLQR7MXOwsJabHIES5vN+ga2WEOy2WgevOTt7szbzwxRSXBMi57njeI4HrB0XfckhNhRUSBxBUrHce7gjTW4poJoqcSlZrzlOcjQ2gVXmqmkQJuu8xyvpeW4ZMZL029TYCUxboM9KWVfjYeagc8fbe0CRqmuOPZVvU0uUYAzZV0Nu/lkj2qmURIwjtBHIdhhbYo1GuH4B/we4BN6/7MRMAabYBecmAIrZEYDDztVOvjHiFGziLEyWljE5L6RCUIffJ0IZd6gOnPKBzfkES1BpeMDSG9Ks88aoHoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suo@2x.png
// module id = lLar
// module chunks = 1